import { store } from '@chilipiper/utils'
import type { DebugMode } from '@chilipiper/web-data-external'
import { getEnv } from './env'

type Logger = {
  error: (...args: unknown[]) => void
  info: (...args: unknown[]) => void
  log: (...args: unknown[]) => void
  warn: (...args: unknown[]) => void
}

export const createLogger = (
  app: string,
  debugKey: string
): Logger & { getMode: () => DebugMode } => {
  const prefix = `[${app}]`

  const getMode = (): DebugMode => {
    const stored = store.get(debugKey)
    if (stored === 'off' || stored === 'error' || stored === 'verbose') return stored
    const env = getEnv('DEPLOY_ENV')
    return env === 'canary' || env === 'production' ? 'error' : 'verbose'
  }

  return {
    getMode,
    error: (...args: unknown[]): void => {
      const mode = getMode()
      if (mode === 'error' || mode === 'verbose') console.error(prefix, ...args) // eslint-disable-line no-console
    },
    info: (...args: unknown[]): void => {
      const mode = getMode()
      if (mode === 'error' || mode === 'verbose') console.info(prefix, ...args) // eslint-disable-line no-console
    },
    log: (...args: unknown[]): void => {
      if (getMode() === 'verbose') console.log(prefix, ...args) // eslint-disable-line no-console
    },
    warn: (...args: unknown[]): void => {
      if (getMode() === 'verbose') console.warn(prefix, ...args) // eslint-disable-line no-console
    },
  }
}
